import React from 'react';
import { Typography, IconButton, Dialog, DialogTitle, DialogContent, } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const PrivacyPolicy = ({ open, onClose }) => {

    return (
        < Dialog open={open} onClose={onClose}
            maxWidth="md"
            fullWidth
            sx={{
                '& .MuiDialog-paper': {
                    margin: 0,
                    height: '70%',
                    borderRadius: '20px',
                }
            }}
        >
            <DialogTitle sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '20px 15px 5px 20px',
                fontWeight: 'bold',
            }}>
                주식회사 미디어커넥티드<br /> 개인정보 처리 방침
                <IconButton aria-label="close" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers >
                <Typography gutterBottom sx={{ fontSize: '1rem' }}>
                주식회사 미디어커넥티드(이하 ‘회사’)는 「개인정보 보호법」 및 관련 법령에 따라 개인정보를 중요하게 관리하며, 안전하고 투명하게 처리하기 위해 아래와 같은 방침을 수립하여 운영하고 있습니다. 본 방침은 회사가 제공하는 유니체크 서비스 이용과 관련하여 이용자의 개인정보 처리에 대한 내용을 포함합니다.</Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>1. 개인정보의 수집 및 이용 목적</strong><br />
                    회사는 유니체크 서비스 제공 및 법적 의무 이행을 위해 다음과 같은 목적으로 개인정보를 수집 및 이용합니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 안전교육 관리 및 인증<br />
                    &nbsp;&nbsp;&nbsp;이용자의 교육 이수 기록 관리<br />
                    &nbsp;&nbsp;&nbsp;법령 준수를 위한 기록 유지<br />
                    2) 서비스 제공 및 개선<br />
                    &nbsp;&nbsp;&nbsp;유니체크 서비스 운영 및 결과 보고<br />
                    &nbsp;&nbsp;&nbsp;고객 관리 및 서비스 품질 개선<br />
                    3) 기타 법적 의무 이행<br />
                    &nbsp;&nbsp;&nbsp;정부기관 요청 및 관련 법령 준수<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>2. 수집하는 개인정보 항목</strong><br />
                    회사는 다음과 같은 항목의 개인정보를 수집합니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 필수 항목<br />
                    &nbsp;&nbsp;&nbsp;성명<br />
                    &nbsp;&nbsp;&nbsp;생년월일<br />
                    &nbsp;&nbsp;&nbsp;성별<br />
                    &nbsp;&nbsp;&nbsp;교육 이수 기록 (교육 일자, 이수 상태 등)<br />
                    2) 자동 수집 항목<br />
                    &nbsp;&nbsp;&nbsp;서비스 이용 로그<br />
                    &nbsp;&nbsp;&nbsp;접속 IP 주소 및 기기 정보<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>3. 개인정보의 수집 방법</strong><br />
                    회사는 다음과 같은 방법으로 개인정보를 수집합니다.<br />
                    유니체크 서비스 가입 및 이용 과정에서 사용자가 직접 입력한 정보<br />
                    안전교육 동영상 시청 완료 후 제출된 정보<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>4. 개인정보의 보유 및 이용 기간</strong><br />
                    회사는 개인정보를 수집 및 이용 목적 달성 시 또는 법적 보유 기간 경과 후 지체 없이
                    파기합니다. 단, 관련 법령에 따라 일정 기간 보관이 필요할 경우 해당 기간 동안 보관합
                    니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 교육 이수 기록<br />
                    &nbsp;&nbsp;&nbsp; 보관 기간: 관련 법령(산업안전보건법 등)에 따른 의무 보관 기간(최대 3년)<br />
                    2) 서비스 이용 기록<br />
                    &nbsp;&nbsp;&nbsp; 보관 기간: 서비스 제공 기간 동안 및 관련 법령에 따른 기간<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>5. 개인정보의 제3자 제공</strong><br />
                    회사는 이용자의 개인정보를 원칙적으로 제3자에게 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 정보 주체의 사전 동의가 있는 경우<br />
                    2) 법령에 따라 제공이 요구되는 경우<br />
                    2) 공공기관 또는 법적 조사 목적으로 요청된 경우<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>6. 개인정보 처리 위탁</strong><br />
                    회사는 서비스 운영의 효율성을 위해 아래와 같이 개인정보 처리 업무를 위탁할 수 있습니다.<br />
                </Typography>
                <Typography gutterBottom >
                    - 수탁 업체: 유니체크 관리 시스템 제공 업체<br />
                    - 위탁 업무 내용: 안전교육 데이터 관리 및 시스템 운영<br />
                    수탁 업체는 관련 법령에 따라 개인정보 보호 의무를 준수합니다.<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>7. 개인정보 보호를 위한 안전 조치</strong><br />
                    회사는 이용자의 개인정보를 안전하게 보호하기 위해 다음과 같은 조치를 시행합니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 기술적 조치<br />
                    &nbsp;&nbsp;&nbsp;암호화된 데이터 저장 및 전송<br />
                    &nbsp;&nbsp;&nbsp;방화벽 및 네트워크 보안 체계 구축<br />
                    2) 관리적 조치<br />
                    &nbsp;&nbsp;&nbsp;개인정보 처리 직원의 최소화<br />
                    &nbsp;&nbsp;&nbsp;정기적인 내부 점검 및 교육<br />
                    2) 관리적 조치<br />
                    &nbsp;&nbsp;&nbsp;개인정보가 저장된 장소의 접근 통제<br />
                    &nbsp;&nbsp;&nbsp;보안 설비 및 감시 체계 운영<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>8. 정보 주체의 권리 및 행사 방법</strong><br />
                    정보 주체는 언제든지 아래와 같은 권리를 행사할 수 있습니다.<br />
                </Typography>
                <Typography gutterBottom >
                    1) 개인정보 열람, 정정, 삭제 요청<br />
                    2) 개인정보 처리 정지 요구<br />
                    3) 개인정보 수집 및 이용 동의 철회<br />
                    권리 행사는 회사의 개인정보 보호 담당자 또는 고객센터를 통해 요청할 수 있으며, 회사는 관련 법령에 따라 적절히 처리합니다.
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>9. 동의 거부 시 불이익 안내</strong><br />
                    정보 주체는 개인정보 제공 및 동의를 거부할 권리가 있습니다. 다만, 필수 정보 제공을 거부할 경우 유니체크 서비스 이용에 제한이 있을 수 있습니다.<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>10. 개인정보 보호 책임자 및 문의</strong><br />
                    회사는 개인정보 보호에 대한 책임을 다하기 위해 아래와 같은 개인정보 보호 책임자를 지정하고 있습니다.<br />
                    책임자: 박정현<br />
                    소속 부서: 개인정보 보호 및 운영팀<br />
                    이메일: mediaconnectedcs@gmail.com<br />
                    연락처: ☏ 02-2275-1071<br />
                </Typography>
                <Typography gutterBottom sx={{marginTop:'15px'}} >
                    <strong>11. 개인정보 처리 방침의 변경</strong><br />
                    본 방침은 2024년 12월 1일부터 적용됩니다.<br />
                    개인정보 처리 방침 변경 시, 변경 사항은 유니체크 서비스 공지사항 또는 이메일을 통해 사전에 안내 드립니다.
                </Typography>
            </DialogContent>
        </Dialog >
    );
}

export default PrivacyPolicy;